import React from "react";
import SkeletonText from "./SkeletonText";

interface Props {
  columnCount: number;
}

const SkeletonTableHeader: React.FC<Props> = ({ columnCount }) => {
  const columns = Array.from({ length: columnCount }, (_x, i) => i);

  return (
    <thead className="bg-rules">
      <tr>
        {columns.map((_column, index) => (
          <th key={index} className="sm:text-left p-3">
            <SkeletonText align="left" bgColor="bg-steel" />
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default SkeletonTableHeader;
